import React from 'react';

export default function Juice0(props) {
    return (
        <svg
            width="23px"
            height="22px"
            viewBox="0 0 23 22"
            version="1.1"
            xmlns="http://www.w3.org/2000/svg"
            xmlnsXlink="http://www.w3.org/1999/xlink"
            {...props}
        >
            {/* Generator: Sketch 48.2 (47327) - http://www.bohemiancoding.com/sketch */}
            <title>0.0</title>
            <desc>Created with Sketch.</desc>
            <defs />
            <g
                id="Engagement"
                stroke="none"
                strokeWidth={1}
                fill="none"
                fillRule="evenodd"
            >
                <g id={0.0} fill="#000000" fillRule="nonzero">
                    <path
                        className={props.className}
                        // eslint-disable-next-line
                        d="M18,0 L18,2 L23,2 L23,0 L18,0 Z M7,0 L6.15625,1.375 C6.15625,1.375 4.644531,3.816406 3.125,6.6875 C2.367188,8.125 1.582031,9.671875 1,11.09375 C0.417969,12.515625 0,13.777344 0,14.90625 C0,18.761719 3.144531,21.90625 7,21.90625 C10.855469,21.90625 14,18.761719 14,14.90625 C14,13.777344 13.582031,12.515625 13,11.09375 C12.417969,9.671875 11.632813,8.125 10.875,6.6875 C9.355469,3.816406 7.84375,1.375 7.84375,1.375 L7,0 Z M7,4 C7.515625,4.859375 8.0625,5.710938 9.125,7.71875 C9.699219,8.808594 10.242188,9.921875 10.71875,11 C11.383244,13.0321105 11.6942792,14.4415344 11.6518555,15.2282715 C11.4926049,18.181533 9.53613788,19.6878838 6.79248047,19.7275391 C4.27302007,19.7639539 2.38414033,17.762384 2.16308594,15.2463379 C2.08584387,14.3671668 2.45856522,12.9517209 3.28125,11 C3.757813,9.921875 4.300781,8.808594 4.875,7.71875 C5.9375,5.710938 6.484375,4.859375 7,4 Z M20,5 L20,7 L23,7 L23,5 L20,5 Z M18,10 L18,12 L23,12 L23,10 L18,10 Z M20,15 L20,17 L23,17 L23,15 L20,15 Z M18,20 L18,22 L23,22 L23,20 L18,20 Z"
                        id="Shape"
                    />
                </g>
            </g>
        </svg>
    );
}



// WEBPACK FOOTER //
// ./src/lib/icons/Juice0.jsx